import { filterPostsByTopicSlug } from '../../lib'
import TopicSection from '../TopicSection'
import { getSubTopics } from '../../reducers'
import { useSelector } from 'react-redux'

interface ParentingViewProps {
  slug: string
}

const NUM_VISIBLE_POSTS = 4

const ParentingView = ({ slug }: ParentingViewProps) => {
  const state = useSelector((state: any) => state)
  const subTopics = getSubTopics(state, slug)

  const { posts } = state

  return (
    <>
      {subTopics.map((topic: any) => {
        const filteredPosts = filterPostsByTopicSlug(posts, topic.slug)
        return (
          <TopicSection
            key={`topic_section_${topic.slug}`}
            posts={filteredPosts.slice(0, NUM_VISIBLE_POSTS)}
            showAllButton={filteredPosts.length > NUM_VISIBLE_POSTS}
            showTopics={false}
            topic={{ name: topic.name, slug: topic.slug }}
          />
        )
      })}
    </>
  )
}

export default ParentingView
